import {Component, OnInit} from '@angular/core';
import {BreadcrumbComponent} from "@shared/components/breadcrumb/breadcrumb.component";
import {FormatMobilePipe} from "@core/pipes/format-mobile.pipe";
import {MatIcon} from "@angular/material/icon";
import {MatTab, MatTabGroup, MatTabLabel} from "@angular/material/tabs";
import {ActivatedRoute} from "@angular/router";
import {DefaultResponse} from "@core/models/Http/DefaultResponse";
import {UserDetails} from "@core/models/UserDetails";
import {BusinessGroup} from "@core/models/BusinessGroup";
import {CatalogsService} from "@core/http/catalogs.service";
import {CreateEditService} from "@core/http/create-edit-service";
import {HttpErrorResponse} from "@angular/common/http";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import {NgIf} from "@angular/common";
import {AuthManagementService} from "@core/service/auth-management.service";

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    FormatMobilePipe,
    MatIcon,
    MatTab,
    MatTabGroup,
    MatTabLabel,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatAccordion,
    NgIf
  ],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {
  // params de ruta (base64)
  param: string | null = null;     // idUsuario
  paramGid: string | null = null;  // idGEMP

  // UI
  userImage: string | null = null;
  userRole: string | undefined;
  grupoEmpresarial: string | undefined;

  // datos
  user: UserDetails;
  blankObject = {} as UserDetails;
  businessGroups: BusinessGroup[] = [];

  constructor(
    private ecService: CreateEditService,
    private catalogsService: CatalogsService,
    private route: ActivatedRoute,
    private httpMsgHandler: HttpMesageHandlerService,
    private authManagement: AuthManagementService
  ) {
    // Leer params de ruta (base64)
    this.route.paramMap.subscribe(params => {
      const param = params.get('param');
      this.param = param ? atob(param) : null;

      const gid = params.get('gid');
      this.paramGid = gid ? atob(gid) : null;
    });

    this.user = new UserDetails(this.blankObject);
    this.userRole = '';
  }

  ngOnInit(): void {
    if (!this.param) return;
    this.getUserDetailsByUsr(this.param!);
  }

  private getUserDetailsByUsr(usr: string): void {
    this.ecService.getUserByUsr(usr).subscribe({
      next: (res: DefaultResponse<UserDetails | UserDetails[]>) => {
        // ⬇⬇ Ajuste minimo: si data es array, toma el primer elemento
        const data: any = (res && 'data' in res) ? (res as any).data : res;
        const user: UserDetails | null = Array.isArray(data) ? (data[0] ?? null) : (data ?? null);
        this.applyUserPayload(user);
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  private applyUserPayload(u: UserDetails | null) {
    if (!u) return;
    u.email = this.removeAccents(u.email);
    this.user = u;
    this.userImage = (u as any)?.imagen
      ? 'data:image/png;base64,' + (u as any).imagen
      : null;
  }

  // ===== Utils =====
  removeAccents(value: string): string {
    return value ? value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : value;
  }
}
